import { SimpleCardStackWrap, WrapCardText } from '@shared/components/core/card/CommonCardStyles';
import { HeaderSectionWrap, HeaderWrap } from '@shared/components/core/headers/HeaderWraps';
import Icons from '@shared/components/core/images/Icons';
import { TruncateTitleSmall } from '@shared/components/core/text/Typography';
import OrganizationMemberInviteModel from '@shared/models/organizations/OrganizationMemberInviteModel';
import OrganizationMemberRole from '@shared/models/organizations/OrganizationMemberRole';
import { OrgContentWrap } from '../CommonOrgStyles';
import InviteDetailStack from './InviteDetailStack';
import InviteDeleteAccess from './InviteRemoveAccess';

export interface IInviteCardStackProps {
    invite: OrganizationMemberInviteModel;
    myRole: OrganizationMemberRole;
}

export default function InviteCardStack({ invite, myRole }: Readonly<IInviteCardStackProps>) {
    if (!myRole || !invite) return null;
    if (!myRole.canRemoveMembers && !myRole.isAdmin) return null;
    return (
        <SimpleCardStackWrap>
            <WrapCardText>
                <HeaderWrap>
                    <HeaderSectionWrap>
                        <Icons name="orgInvite" size={35} />
                        <TruncateTitleSmall>{invite.email}</TruncateTitleSmall>
                    </HeaderSectionWrap>
                    <HeaderSectionWrap>
                        <InviteDeleteAccess invite={invite} />
                    </HeaderSectionWrap>
                </HeaderWrap>
                <OrgContentWrap>
                    <InviteDetailStack hideWrapper hideEmail={true} invite={invite} />
                </OrgContentWrap>
            </WrapCardText>
        </SimpleCardStackWrap>
    );
}
